export enum BIFF_CONFIGURATIONS {
  HP = 'HP',
  MIDDLE_PAGE = 'MIDDLE_PAGE',
  RESULTS = 'RESULTS',
  RESULTS_PARTIAL = 'RESULTS_PARTIAL',
}

type BiffPositions = {
  GPT: string[];
  AFS: string[];
};

/** Slot ids per search-page configuration; the containers are rendered by AdvSearchPage. */
export const POSITIONS: Record<BIFF_CONFIGURATIONS, BiffPositions> = {
  [BIFF_CONFIGURATIONS.HP]: {
    GPT: ['div-gpt-ad-top-3', 'div-gpt-ad-bottom-0', 'div-gpt-ad-middle-3', 'div-gpt-ad-middle-2'],
    AFS: [],
  },
  [BIFF_CONFIGURATIONS.MIDDLE_PAGE]: {
    GPT: ['div-gpt-ad-bottom-0'],
    AFS: [],
  },
  [BIFF_CONFIGURATIONS.RESULTS]: {
    GPT: ['div-gpt-ad-intrip1', 'div-gpt-ad-intrip2', 'div-gpt-ad-bottom', 'div-gpt-ad-bottom2'],
    AFS: ['afs-results-bottom'],
  },
  [BIFF_CONFIGURATIONS.RESULTS_PARTIAL]: {
    GPT: ['div-gpt-ad-intrip1', 'div-gpt-ad-bottom', 'div-gpt-ad-bottom2'],
    AFS: ['afs-results-bottom'],
  },
};
